import { render, staticRenderFns } from "./DialogRenomearContratosNovo.vue?vue&type=template&id=76ae8d2e"
import script from "./DialogRenomearContratosNovo.vue?vue&type=script&lang=js"
export * from "./DialogRenomearContratosNovo.vue?vue&type=script&lang=js"
import style0 from "./DialogRenomearContratosNovo.vue?vue&type=style&index=0&id=76ae8d2e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports